// see here for info about forcing browser mode (i.e. not mis-detecting node):
// https://github.com/gitbrent/PptxGenJS#integration-with-other-libraries

import pptxgenjs from 'pptxgenjs';
import { getBrowser } from '~app/utils/getBrowser';
import { getCanvasImage, toDataURL } from '~app/utils/createImageURL';
import { t } from "~app/AppBundleContext";

const browser = getBrowser();
const supportedBrowser =  browser === "Chrome" || browser === "Firefox";

const getShapeFill = className => {
  switch (className)  {
    case 'red':
      return 'f4999b';
    case 'ltgreen':
      return 'cef8bc';
    case 'dkgreen':
      return '98dd87';
    case 'blue':
      return 'abe0db';
    case 'ltpurple':
      return 'f9e5f9';
    case 'dkpurple':
      return 'd4a6d3';
    case 'tan':
      return 'eee1b7';
    default:
      return 'f4999b';
  }
};

export const createPPT = async (state, bannerURL) => {
  let failedToGetImage = false;

  let pptx = new pptxgenjs();
  pptx.setBrowser(true);
  pptx.setLayout({ width: 10, height: 8 });

  bannerURL = await toDataURL(bannerURL);

  pptx.defineSlideMaster({
    title: 'MASTER_SLIDE',
    objects: [
      {
        'image': {
          data: bannerURL,
          sizing: { type: 'contain' },
          x: 0,
          y: 7.3,
          w: '100%',
          h: 0.7,
        },
      },
    ],
  });

  let introSlide = pptx.addNewSlide('MASTER_SLIDE');
  introSlide
    .addText(
      state.nodeList.present.header.title,
      { x: 0, y: 0, w: '100%', h: 1, fontSize: 24, color:'363636', align: 'c', bold: true }
    )
    .addText(
      state.nodeList.present.header.description,
      { x: '10%', y: 1, fontSize: 16, color: '333333', w: '80%', align: 'l', valign: 'top' }
    );

  if (supportedBrowser) {
    try {
      const flowchartUrl = await getCanvasImage();
      let flowChartSlide = pptx.addNewSlide('MASTER_SLIDE');
      flowChartSlide.addImage({
        data: flowchartUrl,
        x: 1.5,
        y: 0.2,
        w: 7,
        h: 7,
        sizing: {
          type: 'contain',
        },
      });
    }
    catch(error) {
      failedToGetImage = true;
    }
  }

  let nodeListSlides = {};
  const slidesPerPage = 28;
  const slidesPerSide = slidesPerPage / 2;
  state.nodeList.present.nodes.map((node, i) => {

    // create a new slide for every N nodeList items where N = slidesPerPage
    const slideIndex = Math.floor(i / slidesPerPage);

    if (!nodeListSlides[slideIndex]) {
      nodeListSlides[slideIndex] = pptx.addNewSlide('MASTER_SLIDE');
    }

    // place the first N items per slide on the left and last N on the right
    // where N = slidesPerSide
    const xPos = Math.floor(i % slidesPerPage / slidesPerSide) * 5 + 0.2;
    const yPos = i % slidesPerSide * 0.48 + 0.2;
    const shapeFill = getShapeFill(node.className);

    return nodeListSlides[slideIndex]
      .addText(t(node.title), {
        shape: pptx.shapes.RECTANGLE,
        align: 'c',
        x: xPos + 0.15,
        y: yPos,
        w: 4.6,
        h: 0.4,
        fontSize: 14,
        fill: shapeFill,
      })
      .addText(i + 1, {
        x: xPos + 0.12,
        y: yPos + 0.05,
        bold: true,
      });
  });

  let slides = {};

  // IE11 won't load this png. Or others like it.
  const paperclipURL =
    browser === undefined ? ""
    : await toDataURL(require('~app/resources/images/pptxgen/paperclip.jpg'));

  await Promise.all(state.nodeList.present.nodes.map(async (node, i) => {
    const numImages = node.images.filter(image => image !== null).length;

    const textConfig = {
      x: numImages > 0 ? 4.4 : 1,
      y: 1.2,
      w: numImages > 0 ? 5 : 8,
      fontSize: 16,
      align: 'l',
      valign: 'top',
      color: '333333',
    };

    const shapeFill = getShapeFill(node.className);
    slides[i] = pptx.addNewSlide('MASTER_SLIDE');
    slides[i]
      .addText(t(node.title), {
        shape: pptx.shapes.RECTANGLE,
        align: 'c',
        x: 0, y: 0, w: '100%', h: 1, fill: shapeFill,
      })
      .addText(i + 1, {x: 0.5, y: 0.3, fontSize:32, bold: true, color:'333333'})
      .addText(node.description, textConfig);

    if (node.attachments.length) {
      const attachmentString =
        node.attachments.reduce((acc, attachment) =>
          acc.concat(attachment.fileName), [])
        .join(', ');

      slides[i]
      .addImage({
        data: paperclipURL,
        x: 0.3,
        y: 6.9,
        w: 0.25,
        h: 0.25,
      })
      .addText(attachmentString, {
        x: 0.6,
        y: 6.8,
        w: 9,
        fontSize: 12,
        align: 'l',
        valign: 'top',
      });
    }

    return node.images.map((image, imgIndex) =>
      image && slides[i].addImage({
        data: node.images[imgIndex].data,
        x: 0.45,
        y: numImages > 1 ? imgIndex * 2.8 + 1.2 : 2.8,
        w: 3.5,
        h: 2.62,
        sizing: {
          type: 'cover',
        },
      }),
    );
  }));

  // pptx.save('How Science Works Presentation');

  // return failedToGetImage;

  return new Promise(function(resolve, reject){
    try {
      pptx.save(t('powerpoint-title'),
        function() {
          resolve(failedToGetImage);
        }
      );
    }
    catch (error) {
      reject(error);
    }
  });
};



// WEBPACK FOOTER //
// ./src/core/pptxgen.js